import { IAgathaSearchParams } from "./IAgathaSearchParams";

export enum AgathaSchemaParamsEnum {
  admin_content_settings = "admin_content_settings",
  api_key = "api_key",
  boost_news = "boost_news",
  content_id = "content_id",
  content_types = "content_types",
  content_maturity = "content_maturity",
  content_maturities = "content_maturities",
  debug = "debug",
  entity_scores_boost = "entity_scores_boost",
  explain = "explain",
  features = "features",
  fields = "fields",
  filter_controls = "filter_controls",
  grade_level = "grade_level",
  grant_sets = "grant_sets",
  grants = "grants",
  hide_sets = "hide_sets",
  hides = "hides",
  instructional_features = "instructional_features",
  language = "language",
  lexile_level_range = "lexile_level_range",
  needle = "needle",
  needle_analyses = "needle_analyses",
  needle_entity_confidence = "needle_entity_confidence",
  needle_entity_extractor_source = "needle_entity_extractor_source",
  optimizely_attributes = "optimizely_attributes",
  page = "page",
  page_size = "page_size",
  personalize_ranking_boost = "personalize_ranking_boost",
  query_tag_type = "query_tag_type",
  reading_skills = "reading_skills",
  related_to_standards = "related_to_standards",
  related_to_content_ids = "related_to_content_ids",
  search_id = "search_id",
  shape = "shape",
  sort_by = "sort_by",
  strategy = "strategy",
  suggestions_id = "suggestions_id",
  tags = "tags",
  taxonomy_slug = "taxonomy_slug",
  taxonomy_tags = "taxonomy_tags",
  user_attributes = "user_attributes",
  user_id = "user_id",
  veils = "veils",
  version_tag = "version_tag",
}

export interface IParametersSchema {
  [AgathaSchemaParamsEnum.admin_content_settings]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.api_key]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.boost_news]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.content_id]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.content_types]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.content_maturity]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.debug]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.entity_scores_boost]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.explain]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.features]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.fields]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.filter_controls]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.grade_level]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.grant_sets]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.grants]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.hide_sets]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.hides]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.instructional_features]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.language]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.lexile_level_range]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.needle]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.needle_analyses]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.needle_entity_confidence]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.needle_entity_extractor_source]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.optimizely_attributes]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.page]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.page_size]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.personalize_ranking_boost]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.query_tag_type]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.reading_skills]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.related_to_content_ids]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.search_id]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.shape]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.sort_by]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.strategy]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.suggestions_id]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.tags]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.taxonomy_slug]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.user_attributes]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.user_id]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.veils]: IAgathaSearchParams;
  [AgathaSchemaParamsEnum.version_tag]: IAgathaSearchParams;
}
